import { useEffect } from 'react';
import { restorePersistedCache } from '@/lib/apollo';

/**
 * Restores the persisted Apollo cache in the first commit's effects (web plan
 * W4.2). The first render no longer waits for it: reading and parsing the
 * copy on disk (up to 5 MB) used to come before `root.render`, holding back
 * the first render and the request for the page's lazy chunk, which that
 * render starts. main.tsx puts it first inside the providers, so its effect
 * runs before any query subscribes, and the restore tells the queries the
 * first render read (the header's shops count) — see `restorePersistedCache`.
 *
 * It lives here, not in main.tsx: a component declared in main.tsx makes the
 * entry a React Refresh boundary, so a dev edit to it (or to lib/apollo.ts)
 * re-ran main.tsx in place and called createRoot a second time on #root.
 */
export function PersistedCacheRestore(): null {
  useEffect(() => {
    restorePersistedCache();
  }, []);
  return null;
}
